module.exports = __webpack_public_path__ + "img/product-preview-5.b3f7460.png";